export const DEFAULT_PAGE = "welcome";

// Legacy routes that no longer have a DP — redirect to the default tab.
export const LEGACY_REDIRECTS = {
  overview: DEFAULT_PAGE,
};

// The DP record a /smartPath/:page URL renders, or null when it redirects.
// Kept out of the page module so the route loader can use it without
// waiting for the page's chunk.
export const smartPathPageName = (page) =>
  LEGACY_REDIRECTS[page] ? null : page || DEFAULT_PAGE;
